import adminHttp from "/src/api/adminHttp";

const END_POINT = '/api/admin/giveaways';

export default {
    /**
     * GET: Fetch giveaways
     * @param {Object} params - search, status (scheduled|active|finished), per_page, page
     * @returns {Promise<AxiosResponse<any>>}
     */
    index: (params = {}) => adminHttp.get(END_POINT, { params }),

    /**
     * GET: Fetch a specific giveaway
     * @param {number|string} id - The ID of the giveaway
     * @returns {Promise<AxiosResponse<any>>}
     */
    show: (id) => adminHttp.get(`${END_POINT}/${id}`),

    /**
     * POST: Create a new giveaway (coupons are generated by the backend)
     * @param {Object} giveawayData - name, game_id (1 PUBG MOBILE, 3 MLBB; обязательна), starts_at, ends_at, coupons_count
     * @returns {Promise<AxiosResponse<any>>}
     */
    store: (giveawayData) => adminHttp.post(END_POINT, giveawayData),

    /**
     * PUT: Update an existing giveaway
     * @param {number|string} id - The ID of the giveaway
     * @param {Object} giveawayData - name, game_id (1 PUBG MOBILE, 3 MLBB; обязательна), starts_at, ends_at, coupons_count
     * @returns {Promise<AxiosResponse<any>>}
     */
    update: (id, giveawayData) => adminHttp.put(`${END_POINT}/${id}`, giveawayData),

    /**
     * DELETE: Delete a giveaway with its coupons and winners
     * @param {number|string} id - The ID of the giveaway
     * @returns {Promise<AxiosResponse<any>>}
     */
    delete: (id) => adminHttp.delete(`${END_POINT}/${id}`),

    /**
     * GET: Fetch coupons of a giveaway
     * @param {number|string} id - The ID of the giveaway
     * @param {Object} params - per_page (50 by default), page
     * @returns {Promise<AxiosResponse<any>>}
     */
    coupons: (id, params = {}) => adminHttp.get(`${END_POINT}/${id}/coupons`, { params }),

    /**
     * GET: Fetch winners of a giveaway
     * @param {number|string} id - The ID of the giveaway
     * @param {Object} params - per_page (50 by default), page
     * @returns {Promise<AxiosResponse<any>>}
     */
    winners: (id, params = {}) => adminHttp.get(`${END_POINT}/${id}/winners`, { params }),

    /**
     * PATCH: Change reward status of a winner
     * @param {number|string} id - The ID of the giveaway
     * @param {number|string} winnerId - The ID of the winner
     * @param {string} rewardStatus - waiting_contact|contacted|rewarded
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateWinnerRewardStatus: (id, winnerId, rewardStatus) =>
        adminHttp.patch(`${END_POINT}/${id}/winners/${winnerId}`, { reward_status: rewardStatus }),

    /**
     * PATCH: Change description of a coupon
     * @param {number|string} id - The ID of the giveaway
     * @param {number|string} couponId - The ID of the coupon
     * @param {string|null} description - up to 255 characters, null to clear
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateCouponDescription: (id, couponId, description) =>
        adminHttp.patch(`${END_POINT}/${id}/coupons/${couponId}`, { description }),
};
